import { Button, IconButton } from "@mui/material";
import CheckBoxRoundedIcon from "@mui/icons-material/CheckBoxRounded";
import CheckBoxOutlineBlankRoundedIcon from "@mui/icons-material/CheckBoxOutlineBlankRounded";
import { ALL_CAPABILITIES } from "../../../../utils/constants/capabilities";

const CoreCapabilities = ({
  elem,
  isAdmin,
  isChecked,
  onAssign,
  onRevoke,
  isDisabled,
  setSelectedCap,
}) => {
  const colorClass = isAdmin
    ? "text-red-600"
    : isDisabled
    ? "text-lightgray"
    : "text-blue-600";

  const capability = ALL_CAPABILITIES.find((cap) => cap.id === elem.id);

  return (
    <div
      className="flex items-center p-2 border rounded-md"
      style={{ minWidth: "200px" }}
    >
      <IconButton
        onClick={() => (isChecked ? onRevoke(elem.id) : onAssign(elem.id))}
        className={`w-8 h-8 ${colorClass}`}
        disabled={isDisabled}
      >
        {isChecked ? (
          <CheckBoxRoundedIcon />
        ) : (
          <CheckBoxOutlineBlankRoundedIcon />
        )}
      </IconButton>
      <span
        className={`ml-2 text-sm ${
          isAdmin ? "text-red-600" : isDisabled ? "text-lightgray" : ""
        }`}
      >
        <Button
          className="bg-transparent border-transparent cursor-help text-black capitalize "
          onClick={() => setSelectedCap(capability.info)}
        >
          {capability?.label}
        </Button>
      </span>
    </div>
  );
};

export default CoreCapabilities;
